import React from "react";

import IconButton, { IconButtonProps } from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';

export function EditButton(props: IconButtonProps) {
  return <IconButton 
    aria-label="edit" 
    size="medium"
    {...props}
  >
    <EditIcon fontSize="inherit" />
  </IconButton>
}
